import { render, staticRenderFns } from "./DomainContactManagement.vue?vue&type=template&id=0951ed36&"
import script from "./DomainContactManagement.vue?vue&type=script&lang=js&"
export * from "./DomainContactManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports